import React, { useState, useEffect } from 'react';
import './ArtistShowcasePage.css';
import Footer from "../../../components/Footer"; 
import { FaArrowCircleLeft } from "react-icons/fa";
import Artist_navbar from "../Artist_navbar";
import { makeAuthenticatedGETRequest } from "../../services/serverHelper";
import { reviewPoints } from '../../services/apis';
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAccessToken, setRefreshToken } from "../../reducer/slices/authSlice";
import banner from "./assets/portfoliobanner.png";


export default function ArtistShowcasePage() {
    const [dateState, setDateState] = useState([]);
    const [artdata, setArtData] = useState({});
    const [localImages, setLocalImages] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState('hero');
    const [reviews, setReviews] = useState([])
    const [searchParams] = useSearchParams();
    const [id, setId] = useState('');
    const token = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const role = localStorage.getItem("role");
    const location = useLocation();
    
    

    const getFullImageUrl = (imageValue) => {
      if (!imageValue) return "/default-avatar.png";
      let raw = String(imageValue).replace(/[\u0000-\u001F\u007F]+/g, "").trim();
      if (!raw) return "/default-avatar.png";
      if (raw.startsWith("blob:")) return raw;
      if (/^https?:\/\//i.test(raw)) return raw;
      if (raw.startsWith("//")) return "https:" + raw;
      let cleaned = raw
        .replace(/^\/+/, "")
        .replace(/^public\/images\//i, "")
        .replace(/^public\/uploads\//i, "")
        .replace(/^uploads\/performance\//i, "")
        .replace(/^uploads\//i, "")
        .replace(/^images\//i, "")
        .replace(/^api\/v1\/images\//i, "")
        .replace(/^api\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/api\/v1\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/uploads\/performance\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\//i, "")
        .trim();
      const envBase = process.env.REACT_APP_BASE_URL || "https://api.ekalakaar.com";
      const API_HOST = String(envBase).replace(/\/api(\/v?1)?(\/.*)?$/i, "").replace(/\/+$/, "");
      return `${API_HOST}/images/${cleaned}`;
    };  
  
     const getartist = async (id) => {
      try {
        const artistData = await makeAuthenticatedGETRequest(
          `${process.env.REACT_APP_BASE_URL}/artists/profile/${id}`,
          token
        );
        console.log(artistData.data);
        setArtData(artistData.data);
        const dates = artistData?.data?.appliedOpportunities?.map(
          (op) => op?.performanceDate
        );
        setDateState(dates || []);
      } catch (error) {
        console.error(error);
      }
    };  


    const getReviewsForArtist = async (id)=>{
      try {
        const reviewArtist = await makeAuthenticatedGETRequest(
          `${reviewPoints.GET_REVIEWS_BY_ARTIST}/${id}`,
          token
        );
        console.log(reviewArtist.data);
        setReviews(reviewArtist.data);
      } catch (error) {
        console.log(error);
      }
    }
    
    useEffect(() => {
      if(role === "Artist"){
        setId(localStorage.getItem("artId"));
        getartist(localStorage.getItem("artId"))
        getReviewsForArtist(localStorage.getItem("artId"))
      }

      if(role === "Patron"){
        setId(searchParams.get("id"));
        getartist(searchParams.get("id"))
        getReviewsForArtist(searchParams.get("id"))
      }
      // getartist(id);
    }, []);
  
    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
        const sections = ['hero', 'about', 'expertise', 'performance', 'gallery', 'awards', 'contact'];
        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const rect = element.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom >= 100) {
              setActiveSection(section);
              break;
            }
          }
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);
  
    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
  // 1. Photos & Videos Tab Switcher State
    const [mediaTab, setMediaTab] = useState('photos');

    // 2. Cinematic Video Theater Modal State
    const [lightbox, setLightbox] = useState({
      active: false,
      title: '',
      desc: ''
    });

  // Open video theatre
  const openVideoPlayer = (title, desc) => {
    setLightbox({
      active: true,
      title: title.toUpperCase(),
      desc: desc
    });
    document.body.style.overflow = 'hidden';
  };

  // Close video theatre
  const closeVideoPlayer = () => {
    setLightbox({
      active: false,
      title: '',
      desc: ''
    });
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="react-portfolio-app">
      {/* Main Showcase Layout Wrapper */}
      <main className="booking-layout-wrapper">
        
        {/* Platform Breadcrumbs & Heading Header */}
        <header className="booking-header">
          <div className="breadcrumbs">
            <FaArrowCircleLeft onClick={()=> navigate(-1)} style={{fontWeight:"400", fontSize:"1.2rem", color:"#ad2020"}} />
            <span>eKalakaar</span> <i className="fa-solid fa-chevron-right"></i> 
            <span>Verified Artists</span> <i className="fa-solid fa-chevron-right"></i> 
            <span>Showcase Portfolios</span> <i className="fa-solid fa-chevron-right"></i> 
            <span className="current">{artdata?.personalInfo?.firstName} {artdata?.personalInfo?.lastName.charAt(0)}</span>
          </div>
          
          <div className="artist-profile-card">
            {/* Dark Atmospheric Hero Banner Section */}
            <div className="profile-hero-banner">
              <div className='banner-overlay'>
                <div className="profile-avatar-container">
                  <img 
                    loading="lazy"
                    src={getFullImageUrl(artdata?.personalInfo?.avatar?.url)} 
                    alt={artdata?.fullName} 
                    className="profile-avatar-img"
                  />
                  <span className="avatar-status-badge"><i className="fa-solid fa-circle-check"></i></span>
                </div>
                
                <div className="profile-info-block">
                  <div className="profile-name-row">
                    <h1 className="profile-artist-name">{artdata?.personalInfo?.firstName} {artdata?.personalInfo?.lastName.charAt(0)}</h1>
                    <span className="profile-badge-gold">VERIFIED MASTER PERFORMER</span>
                  </div>
                  
                  <p className="profile-artist-headline">Premium Solo Acoustic Singer & Multi-Instrumentalist</p>
                  
                  <div className="profile-meta-row">
                    <span className="portfolio-meta-item rating"><i className="fa-solid fa-star"></i> 5.0 <span className="portfolio-meta-count">(64 reviews)</span></span>
                    <span className="portfolio-meta-separator">•</span>
                    <span className="portfolio-meta-item"><i className="fa-solid fa-location-dot"></i>{artdata?.address?.city}, {artdata?.address?.state} (Available Worldwide)</span>
                    <span className="portfolio-meta-separator">•</span>
                    <span className="portfolio-meta-item"><i className="fa-solid fa-bolt"></i> Booking via eKalakaar Registry</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* White Action Buttons Dock (Action Dock has no Inquiry button, only Media link) */}
            <div className="profile-action-dock">
              <a href="#media" className="btn-secondary-action"><i className="fa-solid fa-images"></i> View Media Gallery</a>
            </div>
          </div>
        </header>

        {/* Centered Single-Column Showcase Layout (No Sidebar) */}
        <div className="artist-portfolio-container">
          
          {/* SECTION 1: ABOUT THE ARTIST & ARTIST PROFILE */}
          <div className="portfolio-section" id="about">
            <h2 className="section-block-title">About The Artist</h2>
            <div className="about-narrative-box" style={{ marginBottom: '24px' }}>
              <p>
                {artdata?.personalInfo?.firstName} is a passionate {artdata?.artInfo?.artType.join(', ')} specializing in {artdata?.artInfo?.artName.join(', ')}. Through dedication, creativity, and continuous 
                learning, they have developed a unique artistic identity that reflects both skill and authenticity. Their work spans {' ',artdata?.performanceInfo?.experience} years, engaging audiences through meaningful artistic expression and memorable experiences. Committed 
                to excellence and innovation, {artdata?.personalInfo?.firstName} continues to explore new creative possibilities while contributing to the 
                growth and appreciation of the arts.</p>
              <p>
                Under eKalakaar's premier booking registry, {artdata?.personalInfo?.firstName}'s travels extensively from his base in
                 Varanasi to perform at luxury wedding cocktail hours, high-profile corporate galas, and select private celebrations. 
                 Backed by a verified track record of 500+ successful events worldwide, he provides fully customizable, self-contained
                  live sound setups to match any intimate or large venue.
              </p>
            </div>

            {/* Artist Profile Details Section */}
            <div className="setup-specifications-box">
              <h3>Artist Profile Details</h3>
              <div className="specs-grid">
                <div className="spec-tile">
                  <div className="icon"><i className="fa-solid fa-guitar"></i></div>
                  <div className="meta">
                    <span className="lbl">Art Type</span>

                    <span className="val"> {artdata?.artInfo?.artType.join(', ')}</span>
                  </div>
                </div>

                <div className="spec-tile">
                  <div className="icon"><i className="fa-solid fa-globe"></i></div>
                  <div className="meta">
                    <span className="lbl">Culture</span>
                    <span className="val">Indian Classical Fusion & Western Acoustic</span>
                  </div>
                </div>

                <div className="spec-tile">
                  <div className="icon"><i className="fa-solid fa-microphone"></i></div>
                  <div className="meta">
                    <span className="lbl">Art Subtype</span>
                    <span className="val">{artdata?.artInfo?.artName.join(', ')}</span>
                  </div>
                </div>

                <div className="spec-tile">
                  <div className="icon"><i className="fa-solid fa-layer-group"></i></div>
                  <div className="meta">
                    <span className="lbl">Category</span>
                    <span className="val">{artdata?.artInfo?.artCategory.join(', ')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION 2: PERFORMANCE PROFILE */}
          {/* <div className="portfolio-section" id="performance-profile">
            <h2 className="section-block-title">Performance Profile</h2>
            <p className="section-sub-info">Explore the performance footprint, historical milestones, and guest outreach achieved by the artist.</p>
            
            <div className="setup-specifications-box" style={{ border: 'none', paddingTop: 0 }}>
              <ul style={{ listStyle: 'none', paddingLeft: 0, display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <li style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-primary)', flexShrink: 0, fontSize: '11px' }}><i className="fa-solid fa-guitar"></i></span>
                  <div>
                    <strong>Kind of Performances Done:</strong> Solo acoustic classic pop vocals, acoustic folk-indie ambient sets, instrumental background music, and live rhythm loop collaborations.
                  </div>
                </li>
                <li style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-primary)', flexShrink: 0, fontSize: '11px' }}><i className="fa-solid fa-location-dot"></i></span>
                  <div>
                    <strong>Places Performed:</strong> Luxury wedding reception hotels, high-profile corporate evening halls, premium private villa beach gardens, and national cultural art festivals.
                  </div>
                </li>
                <li style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-primary)', flexShrink: 0, fontSize: '11px' }}><i className="fa-solid fa-clock"></i></span>
                  <div>
                    <strong>Duration & Times:</strong> 60 to 180 minutes sets.
                  </div>
                </li>
                <li style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-primary)', flexShrink: 0, fontSize: '11px' }}><i className="fa-solid fa-user-group"></i></span>
                  <div>
                    <strong>To Whom (Target Audience):</strong> Sophisticated patrons, newlyweds, corporate banquets.
                  </div>
                </li>
                <li style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-primary)', flexShrink: 0, fontSize: '11px' }}><i className="fa-solid fa-users"></i></span>
                  <div>
                    <strong>Crowd Reached (Outreach):</strong> Over 15,000+ verified guests across 500+ live stage shows.
                  </div>
                </li>
              </ul>
            </div>
          </div> */}

          {/* SECTION 3: PHOTOS & VIDEOS */}
          <div className="portfolio-section" id="media">
            <div className="gallery-tabs-row">
              <button 
                className={`gallery-tab-btn ${mediaTab === 'photos' ? 'active' : ''}`}
                onClick={() => setMediaTab('photos')}
              >
                Photos ({artdata?.performanceInfo?.perfImgs?.length || 0})
              </button>
              <button 
                className={`gallery-tab-btn ${mediaTab === 'videos' ? 'active' : ''}`}
                onClick={() => setMediaTab('videos')}
              >
                Videos ({artdata?.performanceInfo?.perfVideos?.length || 0})
              </button>
            </div>

            {/* Photo Grid Box */}
            {mediaTab === 'photos' && (
              <div className="gallery-content-box active">
                <div className="poptop-photo-grid">
                  {
                    artdata?.performanceInfo?.perfImgs?.map((item, index)=>(
                      <div key={index} className="grid-img-item">
                        <img src={getFullImageUrl(item)} alt="Stage lighting shadow work" />
                      </div>
                    ))
                  }
                </div>
              </div>
            )}

            {/* Video Grid Box */}
            {mediaTab === 'videos' && (
              <div className="gallery-content-box active">
                <div className="poptop-video-list">
                  {
                    artdata?.performanceInfo?.perfVideos.map((item, index)=>(
                    <div key={index} className="video-item-card">
                      <iframe className='video-card-thumb'
                          title='Youtube player'
                          className="product-card-img-top"
                          // sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                          src={item}>
                      </iframe>
                      <h4>{artdata?.performanceInfo?.perfDetails[index]?.eventName || 'Video Title'}</h4>
                      <p>{artdata?.performanceInfo?.perfDetails[index]?.level}</p>
                    </div>

                    ))
                  }
                </div>
              </div>
            )}
          </div>

          {/* SECTION 4: CLIENT REVIEWS */}
          <div className="portfolio-section" id="reviews">
            <div className="reviews-header-block">
              <h2 className="section-block-title">Verified Reviews</h2>
              <div className="overall-score-panel">
                <span className="score-stars"><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i><i className="fa-solid fa-star"></i></span>
                <span className="score-numerical">{reviews.reduce((acc, item) => acc + item.rating, 0) / reviews.length || 0}/ 5.0 Stars</span>
                <span className="total-reviewed">Based on 64 reviews verified by eKalakaar</span>
              </div>
            </div>

            <div className="reviews-list-vertical">
              {
                reviews.map((item, index)=>{
                  return(
                    <div key={index} className="review-item-poptop">
                      <div className="review-meta-row">
                        <div className="client-avatar"><i className="fa-solid fa-user-check"></i></div>
                        <div className="client-info">
                          <h4>{item.userId.firstName}</h4>
                          {/* <span className="event-details"><i className="fa-solid fa-calendar"></i> Private Marriage Gala | Mumbai, IN</span> */}
                        </div>
                        <div className="stars"><i className="fa-solid fa-star"></i> {item.rating}/5</div>
                      </div>
                      <p className="review-comment-body">
                          {item.comment}
                      </p>
                    </div>)

                })
              }

            </div>
          </div>

        </div>
      </main>

      {/* Poptop Style Footer */}
      <footer className="poptop-footer">
        <div className="footer-container">
          <div className="footer-top-row">
            <div className="footer-brand">
              <h2>eKalakaar</h2>
              <p>Connecting verified, authentic cultural master heritage performers with luxury global events, festivals, and private patrons.</p>
            </div>
            <div className="footer-links-group">
              <div className="link-col">
                <h4>PLATFORM SECURE</h4>
                <a href="#/">Payment Protection</a>
                <a href="#/">Cancellation Policies</a>
                <a href="#/">Help Center</a>
              </div>
              <div className="link-col">
                <h4>BOOKINGS</h4>
                <a href="mailto:booking@ekalakaar.com?subject=Booking Inquiry">Get Free Quote</a>
                <a href="https://ekalakaar.com" target="_blank" rel="noreferrer">Browse Performers</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom-row">
            <p>&copy; 2026 eKalakaar Platform. Fully certified and managed portfolio. All Rights Reserved.</p>
            <span className="footer-sig">Vikramaditya Dev</span>
          </div>
        </div>
      </footer>

      {/* Lightbox Modal for Video Player */}
      {lightbox.active && (
        <div className="cinematic-lightbox active">
          <div className="lightbox-overlay" onClick={closeVideoPlayer}></div>
          <div className="lightbox-content">
            <button className="lightbox-close" onClick={closeVideoPlayer}><i className="fa-solid fa-xmark"></i></button>
            <div className="lightbox-video-frame">
              <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', background: 'radial-gradient(circle, #851C2C 0%, #0b0204 100%)' }}>
                <i className="fa-solid fa-play" style={{ fontSize: '60px', color: '#FFFFFF', marginBottom: '15px' }}></i>
                <h4 style={{ color: '#FFFFFF', fontSize: '18px' }}>{lightbox.title}</h4>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px', marginTop: '5px', padding: '0 40px', textAlign: 'center' }}>
                  {lightbox.desc}
                </p>
              </div>
            </div>
            <div className="lightbox-meta">
              <h3>{lightbox.title}</h3>
              <p>{lightbox.desc}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
